module.exports = __webpack_public_path__ + "img/70200.f880deb5.jpg";